import Model from './customer.model'

let storeContent = utils.generateStore({
   Model,
   customers: [],
   selected_customers: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      async filterCustomers(ctx, payload) {
         try {
            ctx.commit('loading', true)
            let data = payload.ref.form_data_

            if (await payload.ref.isValid()) {
               let match = {}

               if(data.email && data.email.length > 0){
                  match['email'] = data.email
               }else if(data.date && data.date.length > 0){
                  match['created_at'] = {
                     $gte: dayjs(`${data.date[0]} 00:00:00`,'DD-MM-YYYY HH:mm:SS').valueOf(),
                     $lte: dayjs(`${data.date[1]} 23:59:59`,'DD-MM-YYYY HH:mm:SS').valueOf(),
                  }
               }
               let res = await api.fetchEndpointSecure({
                  resource: 'commons',
                  action: 'list',
                  data: {
                     rules: {
                        match
                     }
                  },
                  meta_data: {
                     service: "rewards",
                     collection: "customer",
                  }
               })
               ctx.commit('customers', res.result.records);
            }

            ctx.commit('loading', false)
         } catch (err) {
            ctx.commit('loading', false)
            throw err
         }
      },
      handleActions(ctx, payload) {
         if (payload.action === 'customer:view') {
            ctx.getters.router.push({name: 'Customer-View', params: {id: payload.rows[0]._id}})
         }
      },
      async fetchData(ctx) {
         try {
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};